import React, {useState} from "react";
import Grid from '@material-ui/core/Grid';
import classNames from "classnames";
import LineChart from "../../Component/LineChart/LineChart";
import SmallLineChart from "../../Component/SmallLine/SmallLineChart";

import './index.css';

const btnNames = [
  {name: 'Executive View', color: 'blue'},
  {name: 'Operation View',color: 'red'},
  { name: 'Management View', color: 'green'}
  ];

const boxNames = [
  {name: 'Management View', color: 'green', value: [33,36,40,44,42,45]},
  {name: 'Active Alerts',color: 'red', value: [23,26,27,30,32,35]},
  { name: 'Security Incidents', color: 'blue', value: [25,28,31,34, 31, 36]},
  { name: 'Vulnerabilities', color: 'orange', value: [20,22,24,25, 27, 28,30,29]}
];

const lineChartData = [
  {value1:50, value2:48, value3: 37},
  {value1:53, value2:51, value3: 50,},
  {value1:56, value2:58, value3: 54},
  {value1:52, value2:53, value3: 59},
  {value1:48, value2:44, value3: 65},
  {value1:47, value2:42, value3: 53},
  {value1:59, value2:55, value3: 60},
];

const Dashboard = () => {
  const [active, setActive] = useState();

  const handleClick = (index) => {
    setActive(index)
  }

  console.log('set', active)

  return (
    <Grid className='dashboard-wrapper'>
      <Grid className='dashboard-button-block'>
        {btnNames.map((item, i) => {
          return (
            <span
              key={item.name}
              data-color={item.color}
              className={classNames('dashboard-button', active === i && 'dashboard-button-active')}
              onClick={() => handleClick(i)}
            >
              {item.name}
            </span>
          );
        })}
      </Grid>
      <div className="box-wrap" >
        {boxNames.map((box) => {
          return (
            <div data-color={box.color} className="box-item">
              <span className="box-label">{box.name}</span>
              <SmallLineChart dataset={box.value} chartId={box.name} color={box.color}/>
            </div>
          )
        })}
      </div>
      <Grid className='dashboard-chart'>
        <LineChart dataset={lineChartData}/>
      </Grid>
    </Grid>
  );
}

export default Dashboard